import { ClassificationFeature } from '@/types/product';

export default function mapFeatureValues(feature: ClassificationFeature): string {
  return Array.from(new Set(feature.featureValues
    .map(featureValue => [featureValue.value, featureValue.unit?.symbol].filter(Boolean).join(' '))))
    .join(' – ');
}
